<template>
  <div class="classification" :style="{margin:`0 ${config.margin_num}px`, background:`${config.bg_color || 'none'}`}">
    <van-swipe
      ref="swipe"
      :loop="loop"
      :autoplay="2000"
      :duration="duration"
      :show-indicators="false"
      :width="width"
      @change="handleChange"
    >
      <van-swipe-item
        v-for="(item, index) in swipeData"
        @click="handleSelect(item)"
        :key="index"
      >
        <div
          v-if="item.selected_icon || isEditorStatus"
          @click="jump(item.link_data)"
          class="classification-sub"
          :title="item.link_name || '未命名'"
        >
          <img
            :src="item.selected_icon || default_imgurl"
            class="classification-sub-image"
          />
        </div>
        <div v-if="item.name" class="classification-sub-text">
          {{ item.name }}
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>


<script>
import { redirectURL } from "@/js/jump";
export default {
  name: "tms-middle-nav",
  props: ["config", "isEditorStatus"],

  data() {
    return {
      isScroll: false,
      loop: true,
      width: 97,
      duration: 500, // 动画时长默认值
      default_imgurl:
        "https://mktv-in-cdn.mockuai.com/16409406807017668.png",
    };
  },
  computed: {
    swipeData() {
      if (this.loop) {
        return [...this.config.link_data, ...this.config.link_data];
      } else {
        return this.config.link_data;
      }
    },
  },
  mounted() {
    this.isScroll = this.hasScroll();
    if (this.isScroll === false) {
      this.loop = false;
    }
  },
  methods: {
    // 是否存在滚动条
    hasScroll() {
      const el = this.$refs.swipe;
      if (el) {
        const len = this.config.link_data.length;
        const contentW = this.width * len;
        const wrap = el.$el;
        const wrapW = wrap.clientWidth;
        return contentW > wrapW;
      }
      return false;
    },
    handleChange(index) {
      if (!this.loop) return;
      // loop 功能 以下
      const mid = this.swipeData.length / 2;
      if (index === mid) {
        setTimeout(() => {
          if (this.$refs.swipe) {
            this.$refs.swipe.swipeTo(0, { immediate: true });
          }
        }, this.duration);
      }
    },
    handleSelect(item) {
      this.jump(item.link_data);
    },
    jump(link) {
      if (this.isEditorStatus || !link) {
        return;
      }
      redirectURL(link.toString(), "seller");
    },
  },
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>